import React, { useEffect } from 'react';
import { Input, Label, Textarea } from '@jem-open/jem-ui';
import { useMultiProductRecon } from '../MultiProductReconContext';

interface CalendarDetailsFormProps {
  employerName: string;
}

const CalendarDetailsForm = ({ employerName }: CalendarDetailsFormProps) => {
  const { state, setTitle, setDescription, syncAutoCalendarDetails } =
    useMultiProductRecon();

  useEffect(() => {
    syncAutoCalendarDetails(employerName);
  }, [employerName, state.employerPayCycles, state.recons]);

  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <Label htmlFor="mp-title">Title</Label>
        <Input
          id="mp-title"
          type="text"
          value={state.title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Recon event title"
        />
      </div>

      <div className="space-y-1">
        <Label htmlFor="mp-description">Description</Label>
        <Textarea
          id="mp-description"
          value={state.description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Description for the recon event"
          rows={3}
        />
      </div>
    </div>
  );
};

export default CalendarDetailsForm;
